'use client'

import React, {useState} from 'react'
import {Dialog, DialogContent, DialogHeader, DialogTitle} from "@/components/ui/dialog"
import {Tabs, TabsContent, TabsList} from "@/components/ui/tabs"
import {cn} from "@/lib/utils"
import {VisuallyHidden} from "@radix-ui/react-visually-hidden"
import ImageGallery from "@/app/product/[slug]/_component/desktop/image-gallery";
import {SingleProductEnum} from "@/constants/commerce-enum";

interface ProductImageGalleryProps {
    mediaData: any[],
    productName: string
    hasPreviousPrice: boolean
    hasFreeDelivery: boolean
}

export default function ProductImageGallery({
                                                mediaData,
                                                productName,
                                                hasPreviousPrice,
                                                hasFreeDelivery
                                            }: ProductImageGalleryProps) {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedImage, setSelectedImage] = useState(mediaData[0]?.url)
    const [currentIndex, setCurrentIndex] = useState(0)

    const handleImageClick = (image: string, index: number) => {
        setSelectedImage(image)
        setCurrentIndex(index)
    }

    const handlePrevious = () => {
        if (currentIndex > 0) {
            const newIndex = currentIndex - 1
            setCurrentIndex(newIndex)
            setSelectedImage(mediaData[newIndex].url)
        }
    }
    const handleNext = () => {
        if (currentIndex < mediaData.length - 1) {
            const newIndex = currentIndex + 1
            setCurrentIndex(newIndex)
            setSelectedImage(mediaData[newIndex].url)
        }
    }

    return (
        <>
            <ImageGallery
                isModal={false}
                setIsOpen={setIsOpen}
                hasPreviousPrice={hasPreviousPrice}
                hasFreeDelivery={hasFreeDelivery}
                selectedImage={selectedImage}
                productName={productName}
                currentIndex={currentIndex}
                handleNext={handleNext}
                mediaData={mediaData}
                handlePrevious={handlePrevious}
                handleImageClick={handleImageClick}
            />

            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent className="max-w-2xl max-h-[80vh]">
                    <DialogHeader>
                        <DialogTitle className={cn("text-right text-lg font-semibold")}>
                            تصاویر
                        </DialogTitle>
                    </DialogHeader>
                    <VisuallyHidden>
                        <DialogTitle>{`${productName} Image Gallery`}</DialogTitle>
                    </VisuallyHidden>
                    <Tabs defaultValue="official" className="w-full">
                        <TabsList className="w-full justify-center mb-4 flex items-center">
                            {/* Uncomment if needed */}
                            {/* <TabsTrigger
                                value="official"
                                className="w-[250px] data-[state=active]:bg-blue-secondary h-8 text-sm data-[state=active]:text-white text-blue-secondary border border-blue-secondary data-[state=active]:border-blue-secondary ring-0 !data-[state=active]:bg-blue-secondary border-none rounded-2xl"
                            >
                                تصاویر رسمی
                            </TabsTrigger>
                            <TabsTrigger
                                value="customer"
                                className="w-[250px] ring-0 border-none rounded-2xl"
                            >
                                تصاویر خریداران
                            </TabsTrigger> */}
                        </TabsList>
                        <TabsContent value="official">
                            <ImageGallery
                                isModal={true}
                                setIsOpen={setIsOpen}
                                hasPreviousPrice={hasPreviousPrice}
                                hasFreeDelivery={hasFreeDelivery}
                                selectedImage={selectedImage}
                                productName={productName}
                                currentIndex={currentIndex}
                                handleNext={handleNext}
                                mediaData={mediaData}
                                handlePrevious={handlePrevious}
                                handleImageClick={handleImageClick}
                            />
                        </TabsContent>
                        <TabsContent value="customer">
                            <div className="h-[486px] flex items-center justify-center text-muted-foreground">
                                {SingleProductEnum.noImageFromCustomers}
                            </div>
                        </TabsContent>
                    </Tabs>
                </DialogContent>
            </Dialog>
        </>
    )
}